/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Apa_S3Inputs */

const en_mk_tut_apa_s3 = /** @type {(inputs: Mk_Tut_Apa_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**An agent** is not a chatbot. It appears in the assignee list next to people, moves its own work status, and leaves a step-by-step record.`)
};

const id_mk_tut_apa_s3 = /** @type {(inputs: Mk_Tut_Apa_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Agen** bukan chatbot. Ia muncul di daftar penanggung jawab bersama manusia, mengubah status pekerjaannya sendiri, dan meninggalkan catatan langkah demi langkah.`)
};

/**
* | output |
* | --- |
* | "**An agent** is not a chatbot. It appears in the assignee list next to people, moves its own work status, and leaves a step-by-step record." |
*
* @param {Mk_Tut_Apa_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_apa_s3 = /** @type {((inputs?: Mk_Tut_Apa_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Apa_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_apa_s3(inputs)
	return en_mk_tut_apa_s3(inputs)
});